// extracted by mini-css-extract-plugin
module.exports = {"button":"Report_button__3zwFE"};